import collectionData from './collection-data'
import ui from './ui'

const reducer = {
  collectionData,
  ui,
}

export default reducer
